export default {
	messages: {
		de: {
			name: 'Name',
			description: 'Beschreibung',
		},
		en: {
			name: 'Name',
		},
	},
};
